<template>
  <div class="vms-page-header">
    <div class="vms-page-header__copy">
      <div v-if="kicker" class="vms-page-kicker">{{ kicker }}</div>
      <h1 class="vms-page-title">
        <v-icon v-if="icon" color="info" class="mr-2">{{ icon }}</v-icon>
        {{ title }}
      </h1>
      <p v-if="subtitle" class="vms-page-subtitle mb-0">{{ subtitle }}</p>
    </div>
    <div class="vms-page-actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "VmsPageHeader",
  props: {
    kicker: { type: String, default: "" },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "" },
  },
};
</script>
